import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'

import Modal, { openModal } from '../Modal'
import { ModalInner } from '../Image/ModalImage'

const HtmlContainer = styled.div`
  img {
    cursor: pointer;
  }
`

// This component is so that we can catch any images that are in html (rather than markdown) and apply the modal to them
const HtmlRenderer = ({ value }) => {
  const htmlRef = useRef()
  const [images, setImages] = useState([])

  useEffect(() => {
    // Get all the images in the html snippet being rendered
    const images = htmlRef.current.getElementsByTagName('img')

    // add a click event listener for each image which will trigger the modal
    for (const img of images) {
      img.addEventListener('click', (e) => {
        // Set the image src to render in the modal
        openModal(`html-img-${img.src}`)
      })
    }

    // save the images to state as an array so we can use them to create the modals
    setImages(Array.from(images))
  }, [value])

  return (
    <>
      <HtmlContainer
        ref={htmlRef}
        dangerouslySetInnerHTML={{ __html: value }}
      />

      {images.map(
        (img) =>
          console.dir(img) || (
            <Modal opacity={1} fullScreen name={`html-img-${img.src}`}>
              <ModalInner
                dangerouslySetInnerHTML={{
                  __html: img.outerHTML.replace('width="100%"', '')
                }}
              />
            </Modal>
          )
      )}
    </>
  )
}
HtmlRenderer.propTypes = {}

export default HtmlRenderer
